import React from 'react';

import { NotAuthorizedInfo } from '@/components/elements/not-authorized-info';
import { LoaderRoute } from '@/components/elements/route-change-spinner/loader';
import { OrdersEmptyBlock } from '@/components/modules/orders-page/orders/ui/orders-empty-block';
import { ProductItem } from '@/components/modules/orders-page/orders/ui/product-item';
import { StyledOrderPageWrapper } from '@/components/modules/orders-page/styled';
import { useAppSelector } from '@/store/hooks';
import { TOrder } from '@/types/orders';

import { useTranslate } from '@/shared/hooks/use-translate';
import { TabsAnt } from '@/shared/ui/tabs';

import { useGetPreviousOrders } from './hooks/use-get-previous-orders';

type OrderListPageModuleProps = {
    activeOrders: TOrder[];
};

export const OrderListPageModule: React.FC<OrderListPageModuleProps> = ({ activeOrders = [] }) => {
    const { t } = useTranslate();

    const isAuth = useAppSelector((state) => state.user.auth.authenticated);

    const { handlePreviousOrders, isRequested, previousOrders } = useGetPreviousOrders();

    if (!isAuth) {
        return <NotAuthorizedInfo />;
    }

    const loadingContent = (
        <>
            <LoaderRoute />
            {activeOrders?.map((item) => {
                return <ProductItem order={item} key={item.id.toString()} />;
            })}
        </>
    );

    const content = (items: TOrder[], key: string) => {
        if (!isRequested && key === 'item2') return loadingContent;

        return (
            <div>
                {items?.length === 0 && (key !== 'item2' || (isRequested && key === 'item2')) ? (
                    <OrdersEmptyBlock />
                ) : (
                    items && items?.map((item) => <ProductItem order={item} key={item.id.toString()} />)
                )}
            </div>
        );
    };

    const itemsTabs = [
        { label: t('Активные заказы'), key: 'item-1', children: content(activeOrders, 'item1') },
        { label: t('Прошлые заказы'), key: 'item-2', children: content(previousOrders, 'item2') },
    ];

    return (
        <StyledOrderPageWrapper>
            <TabsAnt onChange={handlePreviousOrders} items={itemsTabs} />
        </StyledOrderPageWrapper>
    );
};
